import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import messages from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'

const ErrorBanner = styled.div.attrs(() => ({
  className: 'animated fadeIn'
}))`
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true })
    // You can also log the error to an error reporting service
    console.log({ error: error, info: info })
    this.props.createUserEvent({
      category: 'error',
      data: {
        message: error.message,
        stack: error.stack,
        component_stack: info.componentStack
      }
    })
  }

  render() {
    const { language } = this.props
    let translated = messages[language]

    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <ErrorBanner>
          <Helmet title={translated['500err']} />
          <h1>{translated['500title']}</h1>
          <a href={`/${language === 'en' ? '' : '?lang=' + language}`}>
            {translated['homeLink']}
          </a>
        </ErrorBanner>
      )
    }
    return this.props.children
  }
}

export default LanguageProvider(ErrorBoundary)



// WEBPACK FOOTER //
// ./src/containers/Error/ErrorBoundary.js